import { Trans, useTranslation } from "react-i18next";

const UnauthenticatedMessage: React.FC = () => {
  const { t } = useTranslation("app/router/unauthenticated_message");

  return (
    <div>
      <Trans t={t} i18nKey={"unauthenticated"} />
    </div>
  );
};

export default UnauthenticatedMessage;
